'use strict';
'use es6';

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = mabCopy;

var _immutable = require('immutable');

var _MabCopyActionTypes = require('../actionTypes/MabCopyActionTypes');

var _RequestState = require('../lib/RequestState');

var RequestState = _interopRequireWildcard(_RequestState);

var _AnalyticsActions = require('../actions/AnalyticsActions');

function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj.default = obj; return newObj; } }

var INITIAL_STATE = new _immutable.Map({
  requestState: RequestState.NOT_REQUESTED,
  mabOption: '',
  mabCorrelationId: ''
});

function mabCopy() {
  var state = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : INITIAL_STATE;
  var _ref = arguments[1];
  var type = _ref.type,
      payload = _ref.payload;

  switch (type) {
    case _MabCopyActionTypes.REQUEST_MAB_COPY:
      (0, _AnalyticsActions.trackEvent)('mabRequested', { action: 'mab copy request sent' });
      return state.set('requestState', RequestState.REQUESTED);
    case _MabCopyActionTypes.SUCCEED_GET_MAB_COPY:
      {
        var selectedOption = payload.suggestedOption;
        var correlationId = payload.correlationId;
        (0, _AnalyticsActions.trackEvent)('mab', {
          action: 'mabCopySucceeded',
          selectedOption: selectedOption,
          correlationId: correlationId
        });
        return state.merge({
          requestState: RequestState.SUCCEEDED.setStatusCode(payload.status).setStatusMessage(payload.message),
          mabOption: selectedOption,
          mabCorrelationId: payload.correlationId
        });
      }
    case _MabCopyActionTypes.FAILED_GET_MAB_COPY:
      return state.merge({
        requestState: RequestState.FAILED.setStatusCode(payload.status).setStatusMessage(payload.message)
      });
    case _MabCopyActionTypes.FAILED_GET_MAB_COPY_WITHIN_TIMEOUT:
      return state.merge({
        requestState: RequestState.FAILED.setStatusMessage('Failed to get mab copy within timeout')
      });
    default:
      return state;
  }
}
module.exports = exports['default'];